import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type TypedDocumentString } from 'graphql-request';
import { graphqlRequest } from '~/lib/graphql-client';

export function useGraphqlMutation<T, V = object>(
  mutation: TypedDocumentString<T, V>,
  invalidateQueries?: string[]
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: V) => graphqlRequest(mutation, variables as object),
    onSuccess: () => {
      if (invalidateQueries) {
        invalidateQueries.forEach((queryKey) => {
          queryClient.invalidateQueries({ queryKey: [queryKey] });
        });
      }
    },
    onError: (error) => {
      console.error('GraphQL mutation error:', error);
    },
  });
}
